module.exports = __webpack_public_path__ + "media/src/img/podpis-b8feffe6e90f52172c7cc6d8a3866b8c.png";